export default __webpack_public_path__ + "static/media/allPay.89ee568f.png";